// extracted by mini-css-extract-plugin
export default {"success":"Success_success__RVRL+","image":"Success_image__aIvws","btn":"Success_btn__Hjzxt","message":"Success_message__aTiSF","link":"Success_link__HKzQq"};